import { render, staticRenderFns } from "./IconX.vue?vue&type=template&id=74c07f20&scoped=true"
import script from "./IconX.vue?vue&type=script&lang=js"
export * from "./IconX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c07f20",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconBase: require('/app/components/anyvan/IconBase.vue').default})
